@if (isPaginationDisplayed()) {
  <ul [ngClass]="{ 'pagination-mobile': isMobile(), 'pagination-desktop': !isMobile() }" class="pagination">
    @for (page of firstPages(); track page.label) {
      <li>
        <a
          [ngClass]="{ active: page.label === currentPage() }"
          [queryParams]="page | getPage: currentPage() : nbPage()"
          [routerLink]="[]">
          @if (page.type === "previous") {
            <i [color]="'GREY_LIGHT'" [iconName]="'ARROW_LEFT'" [ngClass]="{ disabled: page.isDisabled }"></i>
          } @else {
            {{ page | getLabel }}
          }
        </a>
      </li>
    }
    @for (page of middlePages(); track page.label) {
      <li>
        <a
          [ngClass]="{ active: page.label === currentPage() }"
          [queryParams]="page | getPage: currentPage() : nbPage()"
          [routerLink]="[]">
          {{ page | getLabel }}
        </a>
      </li>
    }
    @for (page of endPages(); track page.label) {
      <li>
        <a
          [ngClass]="{ active: page.label === currentPage() }"
          [queryParams]="page | getPage: currentPage() : nbPage()"
          [routerLink]="[]">
          @if (page.type === "next") {
            <i [color]="'GREY_LIGHT'" [iconName]="'ARROW_RIGHT'" [ngClass]="{ disabled: page.isDisabled }"></i>
          } @else {
            {{ page | getLabel }}
          }
        </a>
      </li>
    }
  </ul>
}
